<template>
  <g
    class="fill-none"
    :style="[strokeStyle]"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path d="M6 13.223L8.45 16.7a1.05 1.05 0 001.707.051L18 6.828" />
    <path
      d="M12 .749c6.213 0 11.25 5.037 11.25 11.25S18.213 23.249 12 23.249.75 18.212.75 11.999 5.787.749 12 .749z"
      v-if="settings.circle"
    />
  </g>
</template>

<script>
const IconMixin = require("@/mixins/IconMixin").default;

export default {
  name: "IconCheck",
  mixins: [IconMixin],
  data() {
    return {};
  },
  props: {},
  computed: {},
};
</script>
